export default {"src":"/_next/static/media/ic-add-pack.830d33a5.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};